interface ApplicationConfig {
  ENVIRONMENT: string
  api: {
    HOST: string
  }
  roles: {
    ROLE_ADMIN: string
  }
}

export const applicationConfig: ApplicationConfig = {
  ENVIRONMENT: process.env.CV_CLIENT_ENVIRONMENT || 'development',
  api: {
    HOST: process.env.CV_CLIENT_API_HOST || 'http://localhost:3000',
  },
  roles: {
    ROLE_ADMIN: process.env.CV_CLIENT_ROLE_ADMIN_ID || 'role_admin',
  },
};
